import { useState } from "react";
import { useNavigate } from "react-router-dom";
import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function LookupPage() {
  const [code, setCode] = useState("");
  const navigate = useNavigate();
  const submit = (e) => {
    e.preventDefault();
    if (code.trim()) navigate(`/confirmation/${code.trim().toUpperCase()}`);
  };
  return (
    <div className="min-h-screen bg-[#F9F6F0]" data-testid="lookup-page">
      <SiteHeader />
      <div className="pt-32 pb-24 px-6 md:px-10 max-w-md mx-auto">
        <div className="overline">My Booking</div>
        <h1 className="mt-3 font-display text-4xl">Find your reservation</h1>
        <p className="mt-2 text-sm text-[#8C7A6B]">Enter the reference code we sent you (starts with CV‑).</p>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <Label className="overline" htmlFor="code">Reference code</Label>
          <Input
            id="code"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="CV-XXXXXX"
            className="h-12 bg-white border-[#E5E0D8] uppercase tracking-widest"
            data-testid="lookup-code-input"
          />
          <Button type="submit" className="btn-terracotta w-full h-12 rounded-full" data-testid="lookup-submit">
            Find reservation
          </Button>
        </form>
      </div>
      <SiteFooter />
    </div>
  );
}
